import * as React from 'react';
import {observer} from 'mobx-react';
import {UIState} from 'data/UIState';
import {PageSwitcher} from "components/PageSwitcher";
import {Alert} from "components/widgets/Alert";

import './App.pcss';
import {FullPostModalContainer} from "./feed/FeedItem/FullPostModalContainer";
import {BadgeAchievedConfetti} from "./widgets/modal/BadgeAchievedConfetti";
import {ModalContainer} from "./widgets/modal/ModalContainer";
import {CheckInConfetti} from "./widgets/modal/CheckInConfetti";
import {Scheduler} from "components/reservations/Scheduler";
import {Spinner} from "components/widgets/Spinner";
import {computed} from "mobx";
import {AriaLiveRegion} from "components/AriaLiveRegion";
import {JwtExpiryAlert} from "components/widgets/JwtExpiryAlert";

require('moment-timezone');

@observer
export class App extends React.Component<any, {}> {

	constructor(props) {
		super(props);
		UIState.loadSettings().then(()=>{ }).catch(()=>{ });
	}

	componentDidMount() {
		UIState.handleWindowResize();
	}

	render(){
		if(UIState.settings) {
			return (
				<>
					<div className={"hub"}>
						<PageSwitcher />
					</div>

					<ModalContainer />
					<FullPostModalContainer />
					<BadgeAchievedConfetti />
					<CheckInConfetti />
					<Scheduler />
					<Spinner />
					<AriaLiveRegion />
					<JwtExpiryAlert
						token={UIState.token}
						onStillHere={UIState.handleStillHere}
						onExpired={UIState.handleExpired}
					/>
				</>
			);	
		} else {
			return null;
		}
	}

}



